module.exports = __webpack_public_path__ + "img/renault-old.470a46ca.svg";